<template>
  <div class="mt-4 consultar-empresa-filtro">
      <ToogleFilterBox classString="mx-4 px-0" title="Filtrar" :isFilter="true" @filter="filter" @resetFilter="resetFilter">
        <div class="row m-0 w-100 mb-2">
          <b-form-group id="input-group-2" label="Empresa:" label-for="name" class="col-lg-3 col-12 px-1">
            <InputAutocomplete v-if="!isAdmin" :loader="empresaUserAutocompleteLoader" v-model="form.name" />
            <InputAutocomplete v-else :loader="empresaAutocompleteLoader" v-model="form.name" />
          </b-form-group>
          <b-form-group id="input-group-2" label="Serviço:" label-for="produto" class="col-lg-3 col-12 px-1">
              <b-form-select id="produto" v-model="form.produto" :options="produtoOptions"></b-form-select>
          </b-form-group>
          <b-form-group id="input-group-2" label="Período:" label-for="periodo" class="col-lg-3 col-12 px-1">
              <b-form-select id="periodo" v-model="form.periodo" :options="periodoOptions"></b-form-select>
          </b-form-group>
          <b-form-group id="input-group-2" label="E-mail:" label-for="email" class="col-lg-3 col-12 px-1">
              <b-form-input id="email" v-model="form.email" ></b-form-input>
          </b-form-group>                 
        </div>        
      </ToogleFilterBox>
  </div>
</template>

<script>
import Validations from '@/util/Validations'
import { isObject } from "@/util/utils.js"
import EmpresaResource from "@/resources/EmpresaResource"
import UserResource from "@/resources/UserResource"
import InputAutocomplete from "@/components/commons/Inputs/InputAutocomplete"
import ToogleFilterBox from "@/components/commons/ToogleFilterBox.vue";
import { mapGetters } from "vuex"

const produtoOptionsDefault = { value: null, text: '(Selecione uma empresa)'}

export default {
    name: "HistoricoImportacaoFilter",
    components: {
        InputAutocomplete,
        ToogleFilterBox
    },
    data() {
      return {
        form : {
            empresaId: null,
            email: null,
            name: null,
            periodo: null,
            produto: null
        },
        periodoOptions : [
          { value: null, text: '(Selecione)'},
          { value:'1', text:'1 mês'},
          { value:'2', text:'2 meses'},
          { value:'6', text:'6 meses'},
          { value:'12', text:'12 meses'}
        ],
        produtoOptions: [produtoOptionsDefault],
      }
	},
  computed: {
      ...mapGetters("user", ["authorities"]),
      isAdmin () {
          if ( this.authorities ) {
              return this.authorities.includes("ROLE_ADMIN")
          }   
          return false;
      }
  },
  methods: {
      empresaAutocompleteLoader: EmpresaResource.autocomplete,
      empresaUserAutocompleteLoader : UserResource.empresa,
      filter() {
        if( Validations.isEmpty(this.form) ) {
          this.$emit("filter-historico-importacao", {} )    
        }
        else {
            
            if(isObject(this.form.name)) {
                this.form.empresaId = this.form.name.id
            }

            let form = {
                ...this.form,
                empresaId: this.form.empresaId,
                email: this.form.email != null ? this.form.email.trim() : null,
                name: this.form.name != null ? this.form.name.text.toUpperCase() : null,
                periodo: this.form.periodo
            }
            
          this.$emit("filter-historico-importacao", form)
        }        
      },
      resetFilter() {
          for (let key in this.form)
          {
              this.form[key] = null
          }  
      },
      contratoOptions(empresaId = null) {
        EmpresaResource.contratoOptions( empresaId, {showLoader: true})
        .then( options => { 
          this.produtoOptions = [ 
            { value: null, text: '(Selecione)'}, 
            ...options.map(item => { return { value: item.id, text: item.text.split(" - ")[0] } })
            ] 
          })
      }
    },
    watch: {
      "form.name": function(newVal) {
        if(!newVal) {
          this.produtoOptions = [produtoOptionsDefault]
          return
        }

        this.contratoOptions(newVal.id)
      }
    }
}
</script>
<style scoped>
.consultar-empresa-filtro {
	justify-content: space-between;
  color: #707070;
	font-size: 18px;
	text-align: left;
}

.label-filter-cases {
    width: 100%;
    height: 45px;
    color: #EFEFEE !important;    
    background-color: #bbbec0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px !important;
    letter-spacing: 2px !important;
    border-radius: 10px 10px 0px 0px;
    transition: 0.2s;
}

.label-filter-cases:hover{
    cursor: pointer;
    background-color: #9d9fa0;
}

input, select {
    font-size: 14px !important;
    border: 1px solid #bbbec0 !important;  
}

.form-filter-cases, .form-filter-cases-end  {
    width: 100%;
    display: flex;
    padding: 15px 0px;
    flex-wrap: wrap;
    justify-content: flex-start;
    transition: 0.2s;
    background-color: #fff;
    border-radius: 0px 0px 10px 10px;
}

.form-filter-cases-end { 
  justify-content: flex-end;
}

.input-100-filter-cases{
    width: calc(100% - 20px);
    margin: 0px 10px 10px 10px;
}

.input-20-filter-cases {
    width: calc(20% - 20px);
    margin: 0px 10px 10px 10px;
}

.input-40-filter-cases {
    width: calc(40% - 20px);
    margin: 0px 10px 10px 10px;
}

.input-25-filter-cases {
    width: calc(25% - 20px);
    margin: 0px 10px 10px 10px;
}

.input-35-filter-cases {
    width: calc(35% - 20px);
    margin: 0px 10px 10px 10px;
}

.input-15-filter-cases {
    width: calc(15% - 20px);
    margin: 0px 10px 10px 10px;
}

</style>